import React from 'react';
import { Stack } from '@mui/material';

import { MiniCalendar, MyCalendars, OtherCalendars } from '../calendar';

interface Props {
  date: Date;
  showMyCalendar: boolean;
  onNavigate: (date: Date) => void;
  onToggleMyCalendar: (checked: boolean) => void;
}

export const MonthPanel = ({ date, onNavigate, showMyCalendar, onToggleMyCalendar }: Props) => {
  return (
    <Stack gap="1rem">
      <MiniCalendar date={date} onNavigate={onNavigate} />
      <MyCalendars checked={showMyCalendar} onChange={onToggleMyCalendar} />
      <OtherCalendars />
    </Stack>
  );
};
